<template>
  <div clas="class-types-page">
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-sheet elevation="1" class="pa-4">
            <v-row>
              <v-col cols="12">
                <h1>Class Types</h1>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-data-table
                v-if="classTypes && classTypes.length"
                :options="{ itemsPerPage: -1 }"
                sort-by="purchaseDate"
                :headers="headers"
                :items="classTypes">
                <template v-slot:item.attributes.name="{ item }">
                  {{ item.attributes.name }}
                </template>
                <template v-slot:item.id="{ item }">
                  <v-btn block v-if="!item.classSessionTypeMeta" x-small color="primary" depressed @click="createConfig($event, item.id)">
                    create
                  </v-btn>
                  <v-btn block v-if="item.classSessionTypeMeta" x-small color="success" depressed @click="editConfig($event, item.classSessionTypeMeta)">
                    edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="createModal" max-width="600px">
      <v-card class="pa-4">
        <v-card-title>
          <span class="headline">Create Class Type Meta</span>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <label class="mb-2">Description</label>
                <wysiwyg v-model="createForm.description" />
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12">
                <label class="mb-2">Things to know</label>
                <wysiwyg v-model="createForm.misc" />
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="6">
                <v-select
                  outlined
                  v-model="createForm.temperature"
                  :items="temperatureOptions"
                  label="Temperature"
                />
              </v-col>
              <v-col sm="6">
                <v-select
                  outlined
                  v-model="createForm.difficulty"
                  :items="diffictulyOptions"
                  label="Difficulty"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.childcare"
                  label="Childcare"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.withWeights"
                  label="With Weights"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.candlelight"
                  label="Candlelight"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.recorded"
                  label="Recorded"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.specialClass"
                  label="Special Class"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.forMom"
                  label="For Moms"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.freeClass"
                  label="Free Class"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="createForm.nonHeated"
                  label="Non-Heated"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveCreate">Save</v-btn>
          <v-btn @click="createModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editModal" max-width="600px">
      <v-card class="pa-4">
        <v-card-title>
          <span class="headline">Edit Class Type Meta</span>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <label class="mb-2">Description</label>
                <wysiwyg v-model="editForm.description" />
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12">
                <label class="mb-2">Things to know</label>
                <wysiwyg v-model="editForm.misc" />
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="6">
                <v-select
                  outlined
                  v-model="editForm.temperature"
                  :items="temperatureOptions"
                  label="Temperature"
                />
              </v-col>
              <v-col sm="6">
                <v-select
                  outlined
                  v-model="editForm.difficulty"
                  :items="diffictulyOptions"
                  label="Difficulty"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.childcare"
                  label="Childcare"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.withWeights"
                  label="With Weights"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.candlelight"
                  label="Candlelight"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.recorded"
                  label="Recorded"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.specialClass"
                  label="Special Class"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.forMom"
                  label="For Moms"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.freeClass"
                  label="Free Class"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="editForm.nonHeated"
                  label="Non-Heated"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveEdit">Save</v-btn>
          <v-btn @click="editModal = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name: 'ClassTypesPage',

  data() {
    return {
      headers: [
        { text: 'Name', value: 'attributes.name' },
        { text: 'Actions', value: 'id', sortable: false }
      ],
      temperatureOptions: [
        { text: '70°-75°', value: '70°-75°' },
        { text: '75°-80°', value: '75°-80°' },
        { text: '80°-85°', value: '80°-85°' },
        { text: '90°-95°', value: '90°-95°' },
        { text: '110°', value: '110°' }
      ],
      diffictulyOptions: [
        { text: 'Beginner', value: 'beginner' },
        { text: 'Advanced', value: 'advanced' }
      ],
      editModal: false,
      editForm:{},
      createModal: false,
      createForm: {
        description: null,
        misc: null,
        temperature: null,
        childcare: false,
        withWeights: false,
        candelight: false,
        difficulty: null,
        specialClass: false,
        recorded: false,
        forMom: false,
        freeClass: false,
        nonHeated: false,
      }
    };
  },

  computed: {
    ...mapGetters({
      classTypes: 'class-session-type/list'
    }),
    isClassTypesLoading() {
      return this.$store.getters['class-session-type/isFindLoading'];
    }
  },

  methods: {
    createConfig(event, classSessionTypeId) {
      this.createForm.marianaClassSessionTypeId = classSessionTypeId;
      this.createModal = true;
    },
    editConfig(event, classSessionTypeMeta) {
      this.editForm = classSessionTypeMeta;
      this.editModal = true;
    },
    saveCreate() {
      this.$store.dispatch('class-session-type-meta/create', this.createForm)
        .then(() => {
          this.createModal = false;
          this.$store.dispatch('class-session-type/find', { query: { limit: 300, enabled: true } });
        });
    },
    saveEdit() {
      this.$store.dispatch('class-session-type-meta/patch', [ this.editForm.id, this.editForm ])
        .then(() => {
          this.editModal = false;
          this.$store.dispatch('class-session-type/find', { query: { limit: 300, enabled: true } });
        });
    }
  },

  mounted() {
    this.$store.dispatch('class-session-type/find', { query: { limit: 300, enabled: true } });
  },
}
</script>

<style lang="scss">

</style>